import React from 'react';
import './BillingSummary.css';

const BillingSummary = ({ data, onRefresh }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (!data) {
    return (
      <div className="billing-summary">
        <div className="no-data-message">
          <h3>Aucune donnée de facturation</h3>
          <p>Aucun rendez-vous n'a été enregistré pour ce mois.</p>
          <button onClick={onRefresh} className="refresh-button">
            Actualiser
          </button>
        </div>
      </div>
    );
  }

  const { 
    rdv_count, 
    automatic_rdv_count, 
    semi_automatic_rdv_count, 
    manual_rdv_count, 
    statistics,
    month,
    last_updated 
  } = data;

  return (
    <div className="billing-summary">
      <div className="summary-header">
        <h2>Résumé de Facturation - {month}</h2>
        <button onClick={onRefresh} className="refresh-button">
          🔄 Actualiser
        </button>
      </div>

      <div className="summary-cards">
        <div className="summary-card total">
          <div className="card-icon">📅</div>
          <div className="card-content">
            <h3>Total RDV</h3>
            <div className="card-value">{rdv_count}</div>
            <div className="card-subtitle">Ce mois</div>
          </div>
        </div>

        <div className="summary-card automatic">
          <div className="card-icon">🤖</div>
          <div className="card-content">
            <h3>RDV Automatiques</h3>
            <div className="card-value">{automatic_rdv_count}</div>
            <div className="card-subtitle">
              {rdv_count > 0 ? Math.round((automatic_rdv_count / rdv_count) * 100) : 0}% du total
            </div>
          </div>
        </div>

        <div className="summary-card semi-automatic">
          <div className="card-icon">⚙️</div>
          <div className="card-content">
            <h3>RDV Semi-auto</h3>
            <div className="card-value">{semi_automatic_rdv_count}</div>
            <div className="card-subtitle">
              {rdv_count > 0 ? Math.round((semi_automatic_rdv_count / rdv_count) * 100) : 0}% du total
            </div>
          </div>
        </div>

        <div className="summary-card manual">
          <div className="card-icon">✋</div>
          <div className="card-content">
            <h3>RDV Manuels</h3>
            <div className="card-value">{manual_rdv_count}</div>
            <div className="card-subtitle">
              {rdv_count > 0 ? Math.round((manual_rdv_count / rdv_count) * 100) : 0}% du total
            </div>
          </div>
        </div>
      </div>

      <div className="summary-statistics">
        <h3>Statistiques</h3>
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-label">Revenus estimés</div>
            <div className="stat-value revenue">
              {formatCurrency(statistics?.total_revenue_estimate || 0)}
            </div>
          </div>

          <div className="stat-item">
            <div className="stat-label">Moyenne RDV/jour</div>
            <div className="stat-value">
              {statistics?.average_rdv_per_day || 0}
            </div>
          </div>

          <div className="stat-item">
            <div className="stat-label">Agent le plus actif</div>
            <div className="stat-value">
              {statistics?.most_active_agent || 'N/A'}
            </div>
          </div>

          <div className="stat-item">
            <div className="stat-label">Opération la plus demandée</div>
            <div className="stat-value">
              {statistics?.most_requested_operation || 'N/A'}
            </div>
          </div>
        </div>
      </div>

      {last_updated && (
        <div className="summary-footer">
          <p>Dernière mise à jour : {formatDate(last_updated)}</p>
        </div>
      )}
    </div>
  );
};

export default BillingSummary; 